import { DeleteDialog } from "components";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  payment: server.dto.Payment
  isOpen: boolean
  onClose: () => void
}

const DeletePaymentModal = (props: Props) => {
  const { payment, isOpen, onClose } = props;

  const onDelete = async () => {
    await window.CoreApi.Payment.Delete({ paymentId: payment.paymentId });
    window.location.href = routes.payment_List().absolute;
  };

  return <DeleteDialog
    spinForever
    isOpen={isOpen}
    message={RESX.GeneralWarnings.DeleteSure}
    handleClose={onClose}
    onDelete={onDelete}
  />;
};

export default DeletePaymentModal;